import React from 'react';
import { Link } from 'react-router-dom';
import '../styles/Footer.css';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer" style={{ display: 'block', visibility: 'visible' }}>
      <div className="footer-container">
        <div className="footer-content">
          {/* Company Info Section */}
          <div className="footer-section">
            <h3 className="footer-title">KATONOMETRICA S.L.U.</h3>
            <p className="footer-description">
              AI-powered automation that replaces manual work.
            </p>
            <div className="footer-company-info">
              <p>CIF: B21631403</p>
              <p>Pilar de la Horadada, Alicante, Spain</p>
            </div>
          </div>

          {/* Quick Links Section */}
          <div className="footer-section">
            <h4 className="footer-heading">Quick Links</h4>
            <ul className="footer-links">
              <li>
                <Link to="/" className="footer-link">Home</Link>
              </li>
              <li>
                <Link to="/dashboard" className="footer-link">Dashboard</Link>
              </li>
              <li>
                <Link to="/inventory" className="footer-link">Inventory</Link>
              </li>
              <li>
                <Link to="/wallet" className="footer-link">Wallet</Link>
              </li>
            </ul>
          </div>

          {/* Company Links Section */}
          <div className="footer-section">
            <h4 className="footer-heading">Company</h4>
            <ul className="footer-links">
              <li>
                <a 
                  href="https://katonometrica.com" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="footer-link"
                >
                  Our Work
                </a>
              </li>
              <li>
                <a 
                  href="https://katonometrica.com" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="footer-link"
                >
                  Case Studies
                </a>
              </li>
              <li>
                <a 
                  href="https://katonometrica.com" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="footer-link"
                >
                  Portfolio
                </a>
              </li>
              <li>
                <a 
                  href="https://katonometrica.com" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="footer-link"
                >
                  Book Free Consultation
                </a>
              </li>
            </ul>
          </div>

          {/* Contact & Legal Section */}
          <div className="footer-section">
            <h4 className="footer-heading">Contact & Legal</h4>
            <ul className="footer-links">
              <li>
                <a 
                  href="mailto:info@katonometrica.com" 
                  className="footer-link"
                >
                  info@katonometrica.com
                </a>
              </li>
              <li>
                <a 
                  href="https://katonometrica.com/contact" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="footer-link"
                >
                  Contact Us
                </a>
              </li>
              <li>
                <Link to="/privacy" className="footer-link">Privacy Policy</Link>
              </li>
              <li>
                <Link to="/terms" className="footer-link">Terms of Service</Link>
              </li>
            </ul>
          </div>
        </div>

        {/* Copyright Section */}
        <div className="footer-bottom">
          <div className="footer-copyright">
            <p>&copy; {currentYear} KATONOMETRICA S.L.U. All rights reserved.</p>
          </div>
          <div className="footer-branding">
            <p>
              Powered by{' '}
              <a 
                href="https://katonometrica.com" 
                target="_blank" 
                rel="noopener noreferrer"
                className="footer-brand-link"
              >
                Katonometrica
              </a>
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;

